import { render } from "./AuthHome.vue?vue&type=template&id=d084b508&scoped=true"
import script from "./AuthHome.vue?vue&type=script&lang=js"
export * from "./AuthHome.vue?vue&type=script&lang=js"

import "./AuthHome.vue?vue&type=style&index=0&id=d084b508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d084b508"]])

export default __exports__